import { render, staticRenderFns } from "./LayoutLoading.vue?vue&type=template&id=e60cbd54&scoped=true"
import script from "./LayoutLoading.vue?vue&type=script&lang=js"
export * from "./LayoutLoading.vue?vue&type=script&lang=js"
import style0 from "./LayoutLoading.vue?vue&type=style&index=0&id=e60cbd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60cbd54",
  null
  
)

export default component.exports